import React, { useRef, useEffect, useCallback, useState} from 'react';
import {GRID, LIST} from './constants.js';
import ListResults from './ListResults.js';
import UnknownProgressBar from 'components/progressbar/UnknownProgressBar.js';
import {useScroll} from './useScroll.js';
import Day from './Day.js';
import {getSoundResultsServer} from './getSoundResults.js';
import {TAG, DAY} from './constants.js';
import {connect} from 'react-redux';
import {
    setCurrentTagInList} from 'actions/index.js';
    
import {formatDate} from './formatDate.js';
let id = 0;

const SIZE=50;

const SoundGrid = ({
    children,
    sequencerEngine,
    onClickSource,
    onClickDay,
    searchTerm,
    displayOption,
    showPianoRoll,
    setPackToSearch,
    packToSearch,
    bottomHeight,
    guildId,
    groupBy,
    resultsElement,
    setCurrentTagInList,
    currentTagInList,
    filterFavorites,
    setSourceToSearch
}) => { 
    let [results, setResults] = useState([]);
    let [start, setStart] = useState(0);
    let lastQuery = useRef('');
    let [isLoading, setIsLoading] = useState(false);
    let ref = useRef(undefined);
    let pageSize = groupBy ? (window.innerHeight / 500.0) * 50 : 15;
    let {size, scrollPosition} = useScroll(
        ref,
        searchTerm !== "" ? Math.round((window.innerHeight / 500.0) * 10) : Math.round(pageSize),
        true,
        searchTerm,
        groupBy,
        undefined,
        currentTagInList);

    useEffect(() => {
        if (!resultsElement && ref.current) {
            ref.current.scrollTo(0, scrollPosition.current);
        }
    }, [resultsElement]);

    useEffect(() => {
        let query = searchTerm+guildId+groupBy+start+filterFavorites;
        if (query === lastQuery.current) {
            return;
        } 
        if (start === 0) {
            setIsLoading(true);
        }
        lastQuery.current = query;

        let pageSize = groupBy ? (window.innerHeight / 500.0) * 50 : 15;
        getSoundResultsServer(
            pageSize,
            searchTerm, guildId, groupBy, start, filterFavorites)
            .then(r => {
                if (Math.floor(start) == 0) {
                    setResults(r);
                    setCurrentTagInList(0);
                } else if (Math.floor(start) > 0 && r.length > 0) {
                    setResults([... results, ...r]);
                } else {
                }
                setIsLoading(false);
            });
    }, [setResults, sequencerEngine, setIsLoading, start, results, filterFavorites, searchTerm]);

    useEffect(() => {
        setStart(0);
        setResults([]);
    }, [guildId, groupBy, searchTerm, setStart, setResults]);

    useEffect(() => {
        let _size = pageSize;
        setStart(Math.max(0, size - _size))
    }, [size, setStart]);

    let style = {
        height: window.innerHeight - 223
    };
        if (showPianoRoll) {
            style.height -= bottomHeight - 150;
        }

    let listResults = undefined;
    if (displayOption === LIST) {
        if (isLoading) {
            return (<UnknownProgressBar text="Searching sounds"/>);
        };
        listResults = (
            <ListResults
              setPackToSearch={setPackToSearch}
              packToSearch={packToSearch}
              scrollRef={ref}
              searchTerm={searchTerm}
              results={results}
              sequencerEngine={sequencerEngine}/>);
    }

    return (
        <div>
          {resultsElement ? <div>
                              {children}
                              {resultsElement}
                            </div>: ''}
          <div style={style} ref={ref} id="sound-grid" className={resultsElement ? "hide sound-grid no-select" : "no-select sound-grid"}>
            {children}
            {!isLoading && results.length === 0 ? <div className="no-results">No Results Found</div> : ''}
            {isLoading ?
             <UnknownProgressBar text="Searching sounds"/> :
             listResults ? listResults : 
             results.slice(0, size).map(
                 (dayResults, i) =>
                     <Day
                       key={"day-" + i}
                       filterFavorites={filterFavorites}
                       setPackToSearch={setPackToSearch}
                       scrollRef={ref}
                       number={i}
                       isCurrent={!packToSearch && currentTagInList === i}
                       onClickSource={onClickSource}
                       searchTerm={searchTerm}
                       setSourceToSearch={setSourceToSearch}
                       groupBy={groupBy}
                       onClickDay={onClickDay}
                       results={dayResults}/>)}
          </div>
        </div>
    );
}


const mapStateToProps = (state, props) => {
  return {
      showPianoRoll: state.sequencer.showPianoRoll,
      currentTagInList: state.selector.currentTagInList,
      bottomHeight: state.arrangement.bottomHeight,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
        setCurrentTagInList: (s) => dispatch(setCurrentTagInList(s))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SoundGrid);
